// extracted by mini-css-extract-plugin
export default {"resultLine":"NoMoreResults_resultLine__eQNxw"};